import { SpaceDto } from "@braoshzmvavz/picnube-common";
import React from "react";
import { HiPlus } from "react-icons/hi";
import SpaceFormModal from "./SpaceFormModal";

export default function AddSpaceModal(props: {
  onSave: (newSpace: Partial<SpaceDto>) => void;
}) {
  const handleSave = (values: { name: string; description: string }) => {
    props.onSave({
      name: values.name,
      description: values.description,
    });
  };

  return (
    <SpaceFormModal
      onSave={handleSave}
      submitIcon={HiPlus}
      submitLabel="Create Space"
    />
  );
} 